var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3088",
    "data-name": "Rectangle 3088",
    width: 24,
    height: 24,
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_91",
    "data-name": "Mask Group 91",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M4.067,25.294l5.441-5.441a10.115,10.115,0,1,1,2.041,2.041L6.108,27.335a1.446,1.446,0,0,1-2.041-2.041ZM24.814,13.8A7.217,7.217,0,1,0,17.6,21.022,7.217,7.217,0,0,0,24.814,13.8Z",
    transform: "translate(-3.701 -3.701)",
    fill: "#8a8a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcGr);
export default __webpack_public_path__ + "static/media/search_ic_gr.94e87cdaef5b06c170bb536ad56765f3.svg";
export { ForwardRef as ReactComponent };